var React = require('react');
var DefaultLayout = require('./common/layout');
import { Form, FormGroup, Col, ControlLabel, Button } from 'react-bootstrap';
import { CenteredDiv } from './common/basic';
import { FControl, CheckBox } from './common/forms';
import '../public/less/login.less';

const loginForm = React.createClass({
  submitForm: function () {
    this
      ._submit
      .click();
  },

  removeAttribute: function (evt) {
    evt.target.removeAttribute("readOnly");
  },

  render: function () {
    var errorMsg = "";
    if (this.props.location.query.m == "wrong")
      errorMsg = "Wrong email or password.";
    return (
      <div className='loginBackground'>
        <div className='loginContainer'>
          <Form horizontal method="post" formAction="login" autoComplete="on">
            <div className='loginHeader'>
              <div className='loginLogo'></div>

              <div className='loginFormContainer'>
                <h2>Log In</h2>
                <input type="password" style={{ display: 'none' }} />
                <FormGroup>
                  <input type="email" placeholder="Email" name="Email" id="Email" className="form-control" autoComplete="on" readOnly={true}
                    onFocus={this.removeAttribute} />
                </FormGroup>

                <FormGroup>
                  <input type="password" placeholder="Password" name="Password" id="Password" className="form-control" autoComplete="on" readOnly={true}
                    onFocus={this.removeAttribute} />
                </FormGroup>
                <input type="password" style={{ display: 'none' }} />
                <FormGroup>
                  <div className='float-left'>
                    <a href="/ForgotPassword">Forgot my password</a>
                  </div>
                  {/* <div className='float-right'>
                    <a href="/ForgetEmail">Forgot my email</a>
                  </div> */}
                </FormGroup>

                <FormGroup>
                  <CheckBox id='remember'>Remember me</CheckBox>
                </FormGroup>
                <FormGroup>
                  <label className="error">{errorMsg}</label>
                </FormGroup>
              </div>
            </div>
            <input
              type='submit'
              className='hidden'
              ref={(submit) => {
                this._submit = submit;
              }} />
            <label className='submit' onClick={this.submitForm}>LOG IN</label>
          </Form>
        </div>
      </div>
    )
  }
});

module.exports = loginForm;


// WEBPACK FOOTER //
// ./modules/login.jsx